import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Linkedin, Instagram, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import "./dashboard.css";

const Footer = () => {
  return (
    <footer className="smt-footer">
      <Container fluid className="footer-container">
        <Row className="footer-top">
          {/* LOGO */}
          <Col lg={4} md={6} sm={12}>
            <Link style={{marginTop:'-5px'}} to="/" className="footer-logo" aria-label="SearchMyTenders Home">
              <img
                src="/images/logo_white.svg"
                alt="SearchMyTenders logo"
                 width="196"
                 height="34"
                className="img-fluid"
              />
            </Link>

            <p className="footer-text">
              Enterprise Incubation Centre, IIM Lucknow (Noida Campus) <br />
              Block B, Sector 62, Noida, Uttar Pradesh – 201307
            </p>
          </Col>

          {/* QUICK LINKS */}
          <Col lg={2} md={6} sm={12}>
            <h5 className="footer-title" style={{fontSize:'14px'}}>Quick Links</h5>

            <a
              href="/smt_broucher.pdf"
              target="_blank"
              download="SearchMyTenders_Brochure.pdf"
              className="footer-link"
              aria-label="Download Brochure"
            >
              Download Brochure
            </a>

            <Link
              to="/refund-policy"
              className="footer-link"
              aria-label="Refund and Cancellation Policy"
            >
              Refund & Cancellation Policy
            </Link>
          </Col>

          {/* CONTACT */}
          <Col lg={3} md={6} sm={12}>
            <h6 className="footer-title"  style={{fontSize:'14px'}}>Contact Us</h6>

            <a href="mailto:contact@searchmytenders.com" className="footer-text">
              contact@searchmytenders.com
            </a>

            <a href="tel:+919953451600" className="footer-text">
              +91-99534-51600
            </a>

            <a href="tel:+917669955598" className="footer-text">
              +91-76699-55598
            </a>

            <a href="tel:+917669955590" className="footer-text">
              +91-76699-55590
            </a>
          </Col>

          {/* SOCIAL MEDIA */}
          <Col lg={3} md={6} sm={12}>
            <h6 className="footer-title"  style={{fontSize:'14px'}}>Social Media</h6>

            <div className="footer-social">
              <a
                href="https://www.linkedin.com/company/searchmytenders/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>

              <a
                href="https://x.com/searchmytenders"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X (formerly Twitter)"
              >
                <img src="/images/X.png" alt="X" style={{ width: "24px", height: "24px", objectFit: "contain", filter: "brightness(0) invert(1)" }} className="footer-social-img" />
              </a>

              <a
                href="https://www.instagram.com/searchmytenders/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>

              <a
                href="https://www.facebook.com/people/Searchmy-Tenders/100075941421761/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
            </div>
          </Col>
        </Row>

        {/* BOTTOM */}
        <Row className="footer-bottom">
          <Col md={6}>
            <p className="mb-0">
              © 2026 SearchMyTenders. All rights reserved
            </p>
          </Col>

          <Col md={6} className="text-md-end">
            <Link to="/terms" className="footer-bottom-link">
              Terms & Conditions
            </Link>
            <Link to="/privacy" className="footer-bottom-link">
              Privacy Policy
            </Link>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
